<template>
  <el-dialog
    append-to-body
    class="dialog-component-wrapper"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
    <div v-if="showFooter" slot="footer" class="dialog-footer">
      <el-button v-if="showCancel" :type="cancelType" @click="cancel">{{ closeText }}</el-button>
      <el-button
        v-if="showConfirm"
        type="primary"
        :loading="btnLoading"
        :disabled="showCountDown && count > 0"
        @click="confirm"
      >{{ confirmText }}<span v-if="showCountDown && count > 0"> ({{ count }}S)</span></el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  // 只拦截必要的props 剩余根据el-dialog props来
  props: {
    confirmText: {
      type: String,
      default: function() {
        return this.$t('public.confirm')
      }
    },
    closeText: {
      type: String,
      default: function() {
        return this.$t('public.cancel')
      }
    },
    btnLoading: {
      type: Boolean,
      default: false
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelType: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showCountDown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timer: null,
      count: null
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
    // 倒计时
    handleCountDown(count) {
      if (!this.timer) {
        this.count = count
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      } else {
        clearInterval(this.timer)
        this.timer = null
        this.handleCountDown(count)
      }
    }
  }
}
</script>

<style lang="scss">
.dialog-component-wrapper {
  .el-form {
    width: auto;
  }
}
</style>
